import { css, cx } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
const trendingTag = "t1uit59l";
export const TrendingTag = ({
  children
}) => <div className={cx(buttonReset, tagBase, trendingTag)}>{children}</div>;

require("./tag-trending.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-trending.js");